import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import pagesPaths from "../../../shared/routes/pages-paths";
import { store } from "../../../shared/store/index";

class Links extends Component {
  state = {
    isUSUser: false,
  };

  componentDidMount() {
    try {
      const storeState = store.getState();
      const golfers = storeState?.authReducer?.loginReducer?.golfers || [];
      const primaryClubCountry = golfers[0]?.primary_club_country;

      this.setState({
        isUSUser:
          primaryClubCountry === "USA" ||
          primaryClubCountry === "United States",
      });
    } catch (error) {
      console.error("Error accessing store data:", error);
      this.setState({ isUSUser: false });
    }
  }

  render() {
    const { isUSUser } = this.state;

    return (
      <ul className="footer__links">
        <li>
          <a
            className="footer__link"
            href="http://www.usga.org/handicapping/ghin-faqs.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            FAQs
          </a>
        </li>
        <li>
          <NavLink
            className="footer__link"
            activeClassName="is-active"
            to={pagesPaths.contactUs.path}
          >
            CONTACT&nbsp;
            <span aria-hidden="true">US</span>
            <span className="visually-hidden">us</span>
          </NavLink>
        </li>
        <li>
          <a
            className="footer__link"
            href="https://www.usga.org/content/usga/home-page/Handicap-ghin/ghin-privacy-policy.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            PRIVACY POLICY
          </a>
        </li>
        <li>
          <a
            className="footer__link"
            href="https://www.usga.org/content/usga/home-page/Handicap-ghin/ghin-terms-of-service.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            TERMS OF SERVICE
          </a>
        </li>
        {isUSUser && (
          <li>
            <span
              className="footer__link"
              onClick={() => {
                if (
                  window.Optanon &&
                  typeof window.Optanon.ToggleInfoDisplay === "function"
                ) {
                  window.Optanon.ToggleInfoDisplay();
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  if (
                    window.Optanon &&
                    typeof window.Optanon.ToggleInfoDisplay === "function"
                  ) {
                    window.Optanon.ToggleInfoDisplay();
                  }
                }
              }}
              role="button"
              tabIndex={0}
              aria-label="Your privacy choices"
              style={{ cursor: "pointer" }}
            >
              YOUR PRIVACY CHOICES
            </span>
          </li>
        )}
        <li>
          <a
            className="footer__link"
            href="https://www.usga.org/content/usga/home-page/usga-accessibility-statement.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            ACCESSIBILITY
          </a>
        </li>
      </ul>
    );
  }
}
export default Links;
